import $ from 'jquery';

// import { send } from './utils/ga'

var seenAds = [];
var ignoreClicks = [];

function initialise() {
  if (typeof window.Element.prototype.closest !== 'function') {
    console.error && console.error('`closest` polyfill required for @bigfishtv/tank-advertisement-tracking');
    return;
  }

  if (window.IntersectionObserver) {
    var observer = new window.IntersectionObserver(callback, { threshold: 1.0 });
    findAdvertisements().forEach(function (ad) {
      return observer.observe(ad);
    });
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-advertisement]');
    if (el && ignoreClicks.indexOf(el) === -1) {
      track('click', el);
    }
  });
}

function track(action, el) {
  var event = JSON.parse(el.dataset.advertisement);
  if (!event) {
    console.error && console.error('Could not parse "data-advertisement" attribute for node', el);
  }
  var url = getTrackingUrl(action, event);
  if (!url) {
    console.error && console.error('No tracking URL found', action, event);
  }
  $.ajax({
    method: 'POST',
    url: url
  });
  // send({
  //   ...event,
  //   category: 'Advertisements',
  //   action,
  // })
}

function getTrackingUrl(action, id) {
  switch (action) {
    case 'impression':
      return '/_ta_i/' + id;
    case 'click':
      return '/_ta_c/' + id;
  }
}

function findAdvertisements() {
  return Array.from(document.querySelectorAll('[data-advertisement]')).map(toContainer).filter(isUnique);
}

function callback(entries) {
  var newlySeen = entries.filter(isVisibleObserverEntry).map(toTarget).filter(isUnseen);

  if (!newlySeen.length) return;

  newlySeen.forEach(function (el) {
    return track('impression', el);
  });

  seenAds = seenAds.concat(newlySeen);
}

function toContainer(el) {
  var parent = el.closest('section, article');
  if (el !== parent) {
    parent.dataset.advertisement = el.dataset.advertisement;
    ignoreClicks.push(parent);
  }
  return parent;
}

function isUnique(el, i, list) {
  return list.lastIndexOf(el) === i;
}

function isVisibleObserverEntry(intersectionObserverEntry) {
  return intersectionObserverEntry.isIntersecting;
}

function isUnseen(el) {
  return seenAds.indexOf(el) === -1;
}

function toTarget(intersectionObserverEntry) {
  return intersectionObserverEntry.target;
}

export { initialise };
//# sourceMappingURL=index.es.js.map
